import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelServicePlansList from './ModelServicePlanList';
import { getModelServicePlans, getUserProfileWidget } from '../../selectors/index';
import {
  getServicePlansThunk,
  describeServicePlanThunk,
  postServicePlanThunk,
  setServicePlanChangeThunk,
  setServicePlanShowScreenStatusThunk,
  setServicePlanFilteredDataThunk,
  setCurrentPage,
  setPageFilter
} from '../../actions/modelServicePlan';
import { getChecklistTemplateThunk } from '../../actions/checklistTemplates';
import { getChecklistTemplate, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';

const mapStateToProps = state => {
  return {
    servicePlans: getModelServicePlans(state),
    checklistTemplate: getChecklistTemplate(state),
    currentTimezone: getCurrentTimezone(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelServicePlans: (offset, limit, filter, modelCategoryId, modelId) => getServicePlansThunk(offset, limit, filter, modelCategoryId, modelId, 'MODELSERVICEPLANS'),
      saveModelServicePlan: (modelServicePlanId, widgetCode, isApply) => postServicePlanThunk(modelServicePlanId, widgetCode, isApply),
      describeModelServicePlan: (modelCategoryId, modelId, modelServicePlanId) => describeServicePlanThunk(modelCategoryId, modelId, modelServicePlanId, 'MODELSERVICEPLANSEDIT'),
      changeModelServicePlan: selectedModel => setServicePlanChangeThunk(selectedModel),
      setServicePlanShowScreenStatus: status => setServicePlanShowScreenStatusThunk(status),
      getChecklistTemplate: widgetCode => getChecklistTemplateThunk(widgetCode, true),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setServicePlanFilteredDataThunk(filteredData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelServicePlansList);
